// utils/checkAndUpdateToken.js
import { updateFirebaseToken } from "api";
import { firebaseLS, identifierLocalStorage } from "util/localstorage";
import { throttleUpdateFirebaseToken } from "components/NavBar/throttleFirebase";

export const checkAndUpdateToken = async () => {
  if (identifierLocalStorage.get()) {
    const isEnterLogin = firebaseLS.get() === null;
    const isBlock = window?.Notification?.permission === "denied";

    if (isEnterLogin) {
      await throttleUpdateFirebaseToken();
    } else if (
      !isBlock &&
      firebaseLS.get()?.exp &&
      Math.round(Date.now() / 1000) > firebaseLS.get()?.exp
    ) {
      await throttleUpdateFirebaseToken();
    }
  }
};
